/**
 * Datasnap konekcija, za lakše dohvaćanje podataka.
 * Zapravo je konekcija na PHP, ali direktno se dohvaćaju JSON podaci (najčešće je PHP samo passthrough).
 * Podržani i sinkroni zahtjevi.
 */

(function ($) {
	$.dsQuery = function (options) {
		var settings = $.extend({}, $.dsQuery.defaults, options);
		var doneCall = getDoneCallback(settings.done, settings.fail);
		var failCall = getFailCallback(settings.fail);
		var req = $.ajax(settings)
			.done(doneCall)
			.fail(failCall);
		req.settings = settings;
		return req;
	};
	
	$.dsQueryPost = function (options) {
		var settings = $.extend({}, $.dsQueryPost.defaults, options);
		var doneCall = getDoneCallback(settings.done, settings.fail);
		var failCall = getFailCallback(settings.fail);
		var req = $.ajax(settings)
			.done(doneCall)
			.fail(failCall);
		req.settings = settings;
		return req;
	};	

	$.dsQueryPostJSON = function (options) {
		var settings = $.extend({}, $.dsQueryPostJSON.defaults, options);
		var doneCall = getDoneCallback(settings.done, settings.fail);
		var failCall = getFailCallback(settings.fail);
		var req = $.ajax(settings)
			.done(doneCall)
			.fail(failCall);
		req.settings = settings;
		return req;
	};		
	
	function getDoneCallback(callbackDone, callbackFail) {
		var funcDone = callbackDone;
		var funcFail = callbackFail;
		return function (data, textStatus, jqXHR) {
			if (data !== null && typeof data.error !== "undefined") {
				if (data.errorType == "SessionExpired") {
					if (typeof jqXHR.settings.sessionExpired === "function")
						jqXHR.settings.sessionExpired(data, textStatus, jqXHR);
					else
				    	konto.dialogs.login();
				}
				else{					
					var textStatusError = null;
					if (jqXHR.settings && jqXHR.settings.errorOverride){
						textStatusError = 'abort';
					}
					funcFail(data.error, textStatusError, null, true);
				}
			}
			else {
				funcDone(data);
			}
		};
	}
	
	function getFailCallback(callbackFail) {
		return function (jqXHR, textStatus, errorThrown) {
			callbackFail(errorThrown, textStatus, jqXHR);
		};
	}
	
	$.dsQuery.handleAjaxError = function(error, textStatus, jqXHR) {
		KUtils.busy(false);
		var msg = error;
		if (textStatus == "parsererror")
			msg = jqXHR.responseText;
		
		if (textStatus == "abort")
			return;   

		// network error, nema mrežne konekcije
		if ((jqXHR) && (jqXHR.readyState == 0))
			return;
			
		if (msg.indexOf("- nemate pravo na") !== -1 ){
			$('.btnUnosUpisi').last().remove();
			$('.btn-izvrsiUPozadiniGroup').last().remove();
		}

		konto.dialogs.greska({
			autoOpen: true, 
			modal: true,
			content: msg
		});		
	};
	
	$.dsQuery.defaults = {
		url: "",
		async: true,
		done: function (data) { },
		fail: function (error, textStatus, jqXHR, logicalError) {
			$.dsQuery.handleAjaxError(error, textStatus, jqXHR);
		},
		dataType: "",
		data: "",
		type: "GET"
	};
	
	$.dsQueryPost.defaults = {
		url: "",
		async: true,
		done: function (data) { },
		fail: function (error, textStatus, jqXHR, logicalError) {
			$.dsQueryPost.handleAjaxError(error, textStatus, jqXHR);
		},
		dataType: "",
		data: "",
		type: "POST"
	};	

	$.dsQueryPostJSON.defaults = {
		url: "",
		async: true,
		done: function (data) { },
		fail: function (error, textStatus, jqXHR, logicalError) {
			$.dsQueryPostJSON.handleAjaxError(error, textStatus, jqXHR);
		},
		dataType: "",
		data: "",
		type: "POST"
	};		
	
	$.dsQuerySync = function (options) {
		var settings = $.extend({}, $.dsQuery.defaults, options, { async: false });
		settings.success = getDoneCallback(settings.done, settings.fail);
		if (typeof settings.global !== "undefined" && settings.global === false)
			settings.error = getFailCallback(settings.fail);
		return $.ajax(settings);	
	};
		
	$.dsJSON = function (options) {
		var settings = $.extend({}, $.dsQuery.defaults, options, {dataType: "JSON"});
		return $.dsQuery(settings);
	};
	
	$.dsJSONSync = function (options) {
		var settings = $.extend({}, $.dsQuery.defaults, options, {dataType: "JSON"});
		return $.dsQuerySync(settings);
	};
	
	$.dsJSONPost = function (options) {
		var settings = $.extend({}, $.dsQueryPost.defaults, options, {dataType: "JSON"});
		return $.dsQueryPost(settings);
	};	

	$.dsJSONPostJSON = function (options) {
		var settings = $.extend({}, $.dsQueryPost.defaults, options, {dataType: "JSON"});
		return $.dsQueryPostJSON(settings);
	};	
	
	$.dsDirectCall = function (options, synchronous) {
		if (!options.url) {
			var url = options.method;
			options.url = url;
			delete options.method;
		}
		options.url = $.dsConnectorParams.modulBasePath + options.url;
		if (typeof options.data === "undefined") {
		    options.data = {};
		}
		if (typeof options.params === "undefined") {
			options.params = [];
		}
		options.data["dsDirectCall"] = 1;
		options.data["dsParams"] = JSON.stringify(options.params);		
		delete options.params;

		if (synchronous) {
			return $.dsJSONSync(options);
		}
		else {
			return $.dsJSON(options);
		}
	};
	
	$.dsDirectCallPost = function (options) {
		if (!options.url) {
			var url = options.method;
			options.url = url;
			delete options.method;
		}
		options.url = $.dsConnectorParams.modulBasePath + options.controller + "/" + options.url;
		delete options.controller;		
		
		if (typeof options.data === "undefined") {
		    options.data = {};
		}
		if (typeof options.params === "undefined") {
			options.params = [];
		}
		else {
			for(i=0; i<options.params.length; i++){
				options.url += '/' + options.params[i];
			}
			delete options.params;
		}	
		options.data = KUtils.SNDFormType(options.data[0]);		
		return $.dsJSONPost(options);
	};	

	$.dsDirectCallPostJSON = function (options) {
		if (!options.url) {
			var url = options.method;
			options.url = url;
			delete options.method;
		}
		options.url = $.dsConnectorParams.modulBasePath + options.controller + "/" + options.url;
		delete options.controller;		
		
		if (typeof options.data === "undefined") {
		    options.data = {};
		}
		if (typeof options.params === "undefined") {
			options.params = [];
		}
		else {
			for(i=0; i<options.params.length; i++){
				options.url += '/' + options.params[i];
			}
			delete options.params;
		}	

		if(options.data.length == 1){
			options.data = KUtils.SNDFormType(options.data[0]);	
		}
		else{
			var newOptions = []; 
			$.each(options.data, function (key, value) {
				newOptions[key] = KUtils.SNDFormType(value);
			});
			options.data = newOptions;
		}

		var newData = {};
		newData['fld-POST'] = JSON.stringify(options.data);
		options.data = newData;
		return $.dsJSONPostJSON(options);
	};		
	
	$.dsDirectCallSync = function (options) {
		return $.dsDirectCall(options, true);
	};
	
	$.dsConnectorParams = {
		modulBasePath: ""
	};
	
	$.dsObjectToJS = function (data) {
		if (!data)
			return null;
						
		var newData = {};
		$.each(data, function (key, value) {		
			var newKey = key.substring(1).toUpperCase();
			newData[key] = value;
			newData[newKey] = value;
		});
		
		return newData;		
	};
	
	$.dsObjectToUpperCase = function (data) {
		if (!data)
			return null;
						
		var newData = {};
		$.each(data, function (key, value) {		
			var newKey = key.substring(0).toUpperCase();
			newData[key] = value;
			newData[newKey] = value;
		});
		
		return newData;		
	};	
	
} ( jQuery ));